import { createFileRoute } from "@tanstack/react-router";
import TermsOfService from "@/pages/legal/TermsOfService";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Términos del servicio", path: "/legal/terminos-servicio" }]);

export const Route = createFileRoute("/legal/terminos-servicio")({
  head: () => ({
    meta: [
      { title: "Términos del Servicio | SEOEVOLUTION" },
      { name: "description", content: "Términos del servicio y aviso legal de SEOEVOLUTION" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/legal/terminos-servicio" },
      { property: "og:title", content: "Términos del Servicio | SEOEVOLUTION" },
      { property: "og:description", content: "Términos del servicio y aviso legal de SEOEVOLUTION" },
      { name: "twitter:title", content: "Términos del Servicio | SEOEVOLUTION" },
      { name: "twitter:description", content: "Términos del servicio y aviso legal de SEOEVOLUTION" },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/legal/terminos-servicio" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: TermsOfService,
});
